var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7334C14.9658 18.7334 19.0791 14.6289 19.0791 9.6543C19.0791 4.68848 14.9658 0.575195 9.99121 0.575195C5.02539 0.575195 0.920898 4.68848 0.920898 9.6543C0.920898 14.6289 5.03418 18.7334 10 18.7334ZM6.2998 13.6973C5.37695 13.6973 4.88477 13.2139 4.88477 12.2998V7.05273C4.88477 6.12988 5.37695 5.65527 6.2998 5.65527H13.6914C14.6143 5.65527 15.0977 6.12988 15.0977 7.05273V12.2998C15.0977 13.2139 14.6143 13.6973 13.6914 13.6973H6.2998ZM8.2334 9.75977C8.83105 9.75977 9.30566 9.27637 9.30566 8.6875C9.30566 8.09863 8.83105 7.61523 8.2334 7.61523C7.64453 7.61523 7.16113 8.09863 7.16113 8.6875C7.16113 9.27637 7.64453 9.75977 8.2334 9.75977ZM6.37012 12.7568H13.6123C13.9463 12.7568 14.1572 12.5459 14.1572 12.2031V11.377L12.373 9.75098C12.1797 9.56641 11.9248 9.46973 11.6963 9.47852C11.4502 9.46973 11.2129 9.56641 11.002 9.75098L8.97168 11.5615L8.14551 10.8232C7.95215 10.6562 7.74121 10.5684 7.53027 10.5684C7.33691 10.5684 7.13477 10.6562 6.9502 10.8145L5.8252 11.7725V12.2031C5.8252 12.5459 6.02734 12.7568 6.37012 12.7568Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTagIcon);
export default __webpack_public_path__ + "static/media/edit_tag-icon.4827a370d835ff16021a83581e266e6b.svg";
export { ForwardRef as ReactComponent };